<template>
  <div id="trainers-activity-preview">
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>

    <!-- Premium Header -->
    <div class="preview-header">
      <div class="header-gradient"></div>
      <div class="header-backdrop"></div>
      <div class="header-content">
        <div class="header-icon-box">
          <v-icon large color="white">mdi-file-document-outline</v-icon>
        </div>
        <div class="header-text">
          <h1 class="header-title">{{ pageTitle }}</h1>
          <p class="header-subtitle">Activity Details & Approval</p>
        </div>
        <v-btn
          icon
          absolute
          right
          top
          color="white"
          class="close-btn-header"
          @click="closePrompt"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
    <br />
    <br />
    <v-card class="preview-card">
      <v-card-text class="preview-content-area">
        <div class="d-flex justify-center mb-3" v-if="LoadingFlag">
          <v-progress-circular
            indeterminate
            color="primary"
            size="50"
          ></v-progress-circular>
        </div>

        <v-form
          ref="form1"
          v-model="valid1"
          lazy-validation
          v-on:submit.prevent="submitForm"
          v-if="RecordFlag && !LoadingFlag"
        >
          <v-container class="content-container">
            <!-- Info Alert -->
            <v-alert
              type="info"
              prominent
              border="left"
              class="info-alert mb-6"
              v-if="row.JciEventFlag"
              icon="mdi-information-outline"
            >
              <h4 class="alert-title">Automatic Event</h4>
              <p class="alert-text">
                This event is automatically created via MRF of the Host LO.
              </p>
            </v-alert>

            <!-- Approval Remarks Section -->
            <v-card
              elevation="8"
              class="detail-card mb-6"
              v-if="row.ReasonHistory != ''"
            >
              <div class="card-header">
                <v-icon color="primary" class="mr-2"
                  >mdi-comment-text-outline</v-icon
                >
                <h3 class="card-title">Approval Remarks</h3>
              </div>
              <v-divider class="my-0"></v-divider>
              <v-card-text class="card-content">
                <p class="remarks-text" v-html="row.ReasonHistory"></p>
              </v-card-text>
            </v-card>

            <!-- Activity Details Grid -->
            <v-card elevation="8" class="detail-card mb-6">
              <div class="card-header">
                <v-icon color="primary" class="mr-2"
                  >mdi-information-outline</v-icon
                >
                <h3 class="card-title">Activity Details</h3>
              </div>
              <v-divider class="my-0"></v-divider>
              <v-card-text class="card-content">
                <v-row wrap>
                  <!-- Status -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-check-circle-outline</v-icon
                      >
                      Approval Status
                    </div>
                    <v-chip
                      :color="row.MemberActivityStatusColor"
                      text-color="white"
                      class="mt-2"
                      large
                    >
                      {{ row.MemberActivityStatusTxt }}
                    </v-chip>
                  </v-col>

                  <!-- Trainer Name -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-account</v-icon
                      >
                      Trainer Name
                    </div>
                    <p class="detail-value">{{ row.MemberNameTxt }}</p>
                  </v-col>

                  <!-- Date -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-calendar</v-icon
                      >
                      Date
                    </div>
                    <p class="detail-value">{{ row.MemberActivityDateTxt }}</p>
                  </v-col>

                  <!-- Host -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-home-group</v-icon
                      >
                      Host
                    </div>
                    <p class="detail-value">{{ row.HostTxt }}</p>
                  </v-col>

                  <!-- Event Level -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-layers</v-icon
                      >
                      Event Level
                    </div>
                    <p class="detail-value">{{ row.OrganizationTypeName }}</p>
                  </v-col>

                  <!-- Event Type -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-tag</v-icon
                      >
                      Event Type
                    </div>
                    <p class="detail-value">{{ row.EventTypeTxt }}</p>
                  </v-col>

                  <!-- Event Name -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-text-box</v-icon
                      >
                      Event Name
                    </div>
                    <p class="detail-value">{{ row.EventName }}</p>
                  </v-col>

                  <!-- Participant Type -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-account-multiple</v-icon
                      >
                      Participant Type
                    </div>
                    <p class="detail-value">{{ row.CategorySubName }}</p>
                  </v-col>

                  <!-- Training Event Name -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-school</v-icon
                      >
                      Training Event Name
                    </div>
                    <p class="detail-value">{{ row.TrainingEventNameTxt }}</p>
                  </v-col>

                  <!-- Duration -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-clock</v-icon
                      >
                      Duration
                    </div>
                    <p class="detail-value">{{ row.DurationTxt }}</p>
                  </v-col>

                  <!-- Total Participants -->
                  <v-col cols="12" sm="6" lg="3" md="3" class="detail-item">
                    <div class="detail-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-people</v-icon
                      >
                      Total Participants
                    </div>
                    <p class="detail-value">{{ row.TotalParticipants }}</p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Attachments Section -->
            <v-card elevation="8" class="detail-card mb-6">
              <div class="card-header">
                <v-icon color="primary" class="mr-2">mdi-image-multiple</v-icon>
                <h3 class="card-title">Attachments</h3>
              </div>
              <v-divider class="my-0"></v-divider>
              <v-card-text class="card-content">
                <div class="image-gallery" v-if="row.AllImages && row.AllImages.length > 0">
                  <div class="gallery-container">
                    <div
                      class="gallery-item"
                      v-for="(src, index) in row.AllImages"
                      :key="index"
                      :class="getAttachmentColorClass(index)"
                    >
                      <v-chip
                        class="attachment-chip"
                        :class="getAttachmentColorClass(index)"
                        outlined
                        large
                      >
                        <v-icon left>mdi-image</v-icon>
                        Attachment {{ index + 1 }}
                      </v-chip>
                      <img 
                        :src="src" 
                        :alt="`Attachment ${index + 1}`" 
                        class="gallery-image"
                        @click="viewImage(src)"
                      />
                    </div>
                  </div>
                </div>
                <div v-else class="no-images">
                  <v-icon large color="grey lighten-1" class="mb-2">mdi-image-off</v-icon>
                  <p class="grey--text">No attachments available</p>
                </div>
              </v-card-text>
            </v-card>

            <!-- Admin Approval Section -->
            <v-card
              elevation="8"
              class="detail-card approval-card"
              v-if="row.ApprovalFlag"
            >
              <div class="card-header">
                <v-icon color="error" class="mr-2">mdi-shield-admin</v-icon>
                <h3 class="card-title">Admin Approval</h3>
                <v-chip small color="error" text-color="white" class="ml-2"
                  >For Admin Only</v-chip
                >
              </div>
              <v-divider class="my-0"></v-divider>
              <v-card-text class="card-content">
                <v-row wrap>
                  <!-- Event Category -->
                  <v-col cols="12" sm="12" md="4" lg="4">
                    <label class="form-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-folder-open</v-icon
                      >
                      Event Category <small>(optional)</small>
                    </label>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      v-model="EventCategory"
                      :rules="EventCategoryRules"
                      :items="EventCategoryOptions"
                      :loading="EventCategoryOptionsLoading"
                      required
                      outlined
                      dense
                      rounded
                      class="form-control"
                      clearable
                    ></v-autocomplete>
                  </v-col>

                  <!-- Total Points -->
                  <v-col cols="12" sm="12" md="4" lg="4">
                    <label class="form-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-star</v-icon
                      >
                      <span class="text-danger">*</span>Total Points
                    </label>
                    <v-text-field
                      type="number"
                      v-model="TotalPoints"
                      :rules="TotalPointsRules"
                      placeholder="Enter points"
                      outlined
                      dense
                      rounded
                      class="form-control"
                    ></v-text-field>
                  </v-col>

                  <!-- Remarks -->
                  <v-col cols="12" sm="12" md="4" lg="4">
                    <label class="form-label">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-comment-multiple</v-icon
                      >
                      Remarks <small>(optional)</small>
                    </label>
                    <v-text-field
                      v-model="Remarks"
                      placeholder="Enter remarks"
                      outlined
                      dense
                      rounded
                      class="form-control"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Action Buttons -->
                <v-row wrap class="action-buttons mt-6">
                  <v-col align="center" col="12" sm="12" lg="12" md="12">
                    <v-btn
                      @click.prevent="confirmAlert(1)"
                      :loading="ApproveLoadingFlag"
                      color="success"
                      elevation="6"
                      rounded
                      large
                      class="action-btn approve-btn"
                    >
                      <v-icon left>mdi-check-circle</v-icon>
                      Approve
                    </v-btn>
                    <v-btn
                      @click.prevent="confirmAlert(0)"
                      :loading="ApproveRejectLoadingFlag"
                      color="warning"
                      elevation="6"
                      rounded
                      large
                      class="action-btn reject-btn"
                    >
                      <v-icon left>mdi-close-circle</v-icon>
                      Reject
                    </v-btn>
                    <v-btn
                      @click="closePrompt"
                      color="primary"
                      elevation="6"
                      rounded
                      large
                      class="action-btn cancel-btn"
                    >
                      <v-icon left>mdi-cancel</v-icon>
                      Cancel
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

    <script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    previewRecordFlag: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageTitle: {
      type: String,
    },
  },

  data() {
    return {
      Width: 500,

      valid1: false,
      valid2: false,
      ProgressLoadingFlag: false,
      ResultFlag: false,
      RecordFlag: false,
      LoadingFlag: false,
      row: {},
      PaymentDetails: {},
      selected: [],

      Remarks: "",
      RemarksRules: [
        // (v) => !!v || "Event Category is required"
      ],

      ApprovedDate: new Date().toISOString().slice(0, 10),
      menu1: false,

      ApproveLoadingFlag: false,
      ApproveRejectLoadingFlag: false,
      ConfirmationLoadingFlag: false,
      ConfirmationRejectLoadingFlag: false,

      EventCategoryOptionsLoading: false,
      EventCategoryOptions: [],
      EventCategoryRules: [
        // (v) => !!v || "Event Category is required"
      ],
      EventCategory: "",

      TotalPoints: 0,
      TotalPointsRules: [
        // (v) => !!v || "Total participants is required"
      ],

      dialog: false,
      dialog1: false,

      tableColumns: [],
      tableOptions: [],
      tableData: [],
    };
  },
  computed: {},
  watch: {
    EventCategoryOptions: function () {
      console.log("watch EventCategoryOptions called");
      this.EventCategoryOptionsLoading = false;
    },
    row: function () {
      console.log("watch row");
      var tr = this.row;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.TotalPoints = tr.TrainingEventPoints;
        this.EventCategory = tr.TrainingEventId;
      }
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    getAttachmentColorClass(index) {
      const colors = ['color-primary', 'color-success', 'color-warning', 'color-danger', 'color-info'];
      return colors[index % colors.length];
    },
    viewImage(src) {
      console.log("viewImage called", src);
      // Open image in a lightbox or modal if needed
      window.open(src, "_blank");
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt", this.ResultFlag);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var recordData = this.recordData;
      console.log("recordData=" + JSON.stringify(recordData));
      this.getTableRecords();
      this.getEventCategoryOptions();
    },
    getEventCategoryOptions() {
      console.log("getEventCategoryOptions called");

      this.EventCategoryOptionsLoading = true;
      var selectbox1_source = "EventCategory";
      var selectbox1_destination = "EventCategoryOptions";
      var selectbox1_url = "api/training-event/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var id = this.recordData.MemberActivityId;
      console.log({ id });

      if (id > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/member-activity/show";
        var upload = {
          UserInterface: 1,
          Activity: id,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.row = {};
        this.RecordFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.Documentpath = "";

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            thisIns.RecordFlag = flag;

            if (flag == 1) {
              thisIns.row = records;
              console.log("records=" + JSON.stringify(records));
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
    confirmAlert(status) {
      console.log("confirmAlert is called");
      console.log({ status });
      var htmlTxt = "";

      //   var validate = this.$refs.form1.validate();
      var validate = true;
      console.log({ validate });

      if (validate) {
        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            switch (status) {
              case 0:
                this.approvalSubmitForm(3);

                break;

              case 1:
                this.approvalSubmitForm(1);

                break;

              default:
                break;
            }
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      }
    },
    approvalSubmitForm(status) {
      console.log("approvalSubmitForm is called");

      console.log({ status });

      var tr = this.row;
      console.log({ tr });

      this.ProgressLoadingFlag = true;
      this.ResultFlag = false;

      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var server_url = companyConfig.apiURL;
      var add_url = server_url + "api/member-activity/approval";
      console.log({ add_url });

      var upload = {
        UserInterface: 1,
        TrainerActivity: tr.MemberActivityId,
        Member: tr.MemberId,
        EventCategory: this.EventCategory,
        TotalPoints: this.TotalPoints,
        Remarks: this.Remarks,
        Status: status,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = {};
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ProgressLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.ResultFlag = true;
            thisIns.closePrompt();
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SearchFlag = false;
          thisIns.ProgressLoadingFlag = true;
        });
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
    <style lang="scss" scoped>
// Color Palette
$primary-color: #667eea;
$secondary-color: #764ba2;
$gradient-main: linear-gradient(
  135deg,
  $primary-color 0%,
  $secondary-color 100%
);
$success-color: #10b981;
$warning-color: #f59e0b;
$danger-color: #f44336;
$text-primary: #1a202c;
$text-secondary: #555;
$border-color: #e2e8f0;
$bg-light: #f7f9fc;

// Animation Keyframes
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

#trainers-activity-preview {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;

  // ============================================
  // HEADER SECTION
  // ============================================
  .preview-header {
    background: $gradient-main;
    position: relative;
    overflow: hidden;
    padding: 32px 24px;
    animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 12px 40px rgba(102, 126, 234, 0.3);

    .header-gradient {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: $gradient-main;
      opacity: 1;
    }

    .header-backdrop {
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 70%
      );
      animation: rotate 20s linear infinite;
    }

    .header-content {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      gap: 20px;
    }

    .header-icon-box {
      background: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(10px);
      border-radius: 14px;
      padding: 12px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      animation: float 3s ease-in-out infinite;
      flex-shrink: 0;
    }

    .header-text {
      flex: 1;

      .header-title {
        font-size: 28px;
        font-weight: 800;
        color: white;
        margin: 0;
        letter-spacing: 0.5px;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
      }

      .header-subtitle {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.9);
        margin: 8px 0 0 0;
        letter-spacing: 0.3px;
      }
    }

    .close-btn-header {
      position: absolute !important;
      right: 12px !important;
      top: 12px !important;
      background: rgba(255, 255, 255, 0.15) !important;
      backdrop-filter: blur(10px);
      border: 2px solid rgba(255, 255, 255, 0.3);
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.25) !important;
        transform: rotate(90deg);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
      }
    }
  }

  // ============================================
  // PREVIEW CARD
  // ============================================
  .preview-card {
    border-radius: 16px !important;
    margin: -20px 12px 24px 12px;
    border: none;
    box-shadow: 0 20px 60px rgba(102, 126, 234, 0.2) !important;
    animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s backwards;
  }

  // ============================================
  // CONTENT AREA
  // ============================================
  .preview-content-area {
    padding: 32px;
    animation: fadeIn 0.8s ease-out 0.4s backwards;
  }

  .content-container {
    padding: 0;
  }

  // ============================================
  // INFO ALERT
  // ============================================
  .info-alert {
    border-radius: 12px !important;
    background: linear-gradient(
      135deg,
      rgba(33, 150, 243, 0.12) 0%,
      rgba(119, 235, 255, 0.08) 100%
    ) !important;
    border-left: 5px solid #2196f3 !important;
    box-shadow: 0 8px 24px rgba(33, 150, 243, 0.15) !important;
    padding: 16px 20px !important;
    animation: slideDown 0.6s ease-out;

    ::v-deep {
      .v-alert__icon {
        color: #2196f3 !important;
        align-self: flex-start !important;
      }
    }

    .alert-title {
      font-size: 14px;
      font-weight: 700;
      color: #2196f3;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      margin: 0;
    }

    .alert-text {
      font-size: 13px;
      color: #1565c0;
      margin: 4px 0 0 0;
      font-weight: 500;
    }
  }

  // ============================================
  // DETAIL CARDS
  // ============================================
  .detail-card {
    border-radius: 14px !important;
    border: none;
    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.15) !important;
    transition: all 0.3s ease;
    animation: slideInUp 0.6s ease-out backwards;

    &:hover {
      box-shadow: 0 16px 48px rgba(102, 126, 234, 0.25) !important;
      transform: translateY(-4px);
    }

    .card-header {
      display: flex;
      align-items: center;
      padding: 20px;
      background: linear-gradient(
        135deg,
        rgba(102, 126, 234, 0.08) 0%,
        rgba(118, 75, 162, 0.08) 100%
      );
      border-bottom: 3px solid $primary-color;
      gap: 12px;

      .card-title {
        font-size: 16px;
        font-weight: 700;
        color: $text-primary;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        flex-grow: 1;
      }

      .v-chip {
        flex-shrink: 0;
      }
    }

    .card-content {
      padding: 24px;
    }
  }

  // ============================================
  // DETAIL ITEMS
  // ============================================
  .detail-item {
    animation: slideInUp 0.6s ease-out backwards;

    .detail-label {
      font-size: 12px;
      font-weight: 700;
      color: $text-primary;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      opacity: 0.8;
    }

    .detail-value {
      font-size: 14px;
      font-weight: 600;
      color: $text-secondary;
      margin: 8px 0 0 0;
      padding: 10px;
      background: $bg-light;
      border-radius: 8px;
      border-left: 3px solid $primary-color;
    }

    .v-chip {
      font-weight: 600;
    }
  }

  // ============================================
  // REMARKS
  // ============================================
  .remarks-text {
    font-size: 14px;
    line-height: 1.8;
    color: $text-secondary;
    padding: 12px;
    background: $bg-light;
    border-radius: 8px;
    border-left: 3px solid $primary-color;
    margin: 0;
  }

  // ============================================
  // IMAGE GALLERY
  // ============================================
  .image-gallery {
    width: 100%;

    .gallery-container {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      align-items: flex-start;
    }

    .gallery-item {
      flex: 0 0 auto;
      animation: fadeIn 0.6s ease-out;
      display: flex;
      flex-direction: column;
      gap: 12px;
      align-items: center;

      .attachment-chip {
        font-weight: 700 !important;
        font-size: 12px !important;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        transition: all 0.3s ease !important;
        cursor: pointer;

        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
        }

        ::v-deep .v-chip__content {
          padding: 0 12px;
        }

        ::v-deep .v-icon {
          margin-right: 8px !important;
          font-size: 18px !important;
        }
      }

      .gallery-image {
        width: 120px;
        height: 120px;
        border-radius: 12px;
        object-fit: cover;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
        transition: all 0.3s ease;
        border: 3px solid transparent;
        cursor: pointer;

        &:hover {
          transform: scale(1.08);
          box-shadow: 0 12px 32px rgba(102, 126, 234, 0.25);
          border-color: $primary-color;
        }
      }

      // Color variations for attachment chips
      &.color-primary {
        .attachment-chip {
          border-color: $primary-color !important;
          color: $primary-color !important;
          background: rgba($primary-color, 0.08) !important;

          ::v-deep .v-icon {
            color: $primary-color !important;
          }

          &:hover {
            background: rgba($primary-color, 0.12) !important;
          }
        }
      }

      &.color-success {
        .attachment-chip {
          border-color: $success-color !important;
          color: $success-color !important;
          background: rgba($success-color, 0.08) !important;

          ::v-deep .v-icon {
            color: $success-color !important;
          }

          &:hover {
            background: rgba($success-color, 0.12) !important;
          }
        }
      }

      &.color-warning {
        .attachment-chip {
          border-color: $warning-color !important;
          color: $warning-color !important;
          background: rgba($warning-color, 0.08) !important;

          ::v-deep .v-icon {
            color: $warning-color !important;
          }

          &:hover {
            background: rgba($warning-color, 0.12) !important;
          }
        }
      }

      &.color-danger {
        .attachment-chip {
          border-color: $danger-color !important;
          color: $danger-color !important;
          background: rgba($danger-color, 0.08) !important;

          ::v-deep .v-icon {
            color: $danger-color !important;
          }

          &:hover {
            background: rgba($danger-color, 0.12) !important;
          }
        }
      }

      &.color-info {
        .attachment-chip {
          border-color: #2196f3 !important;
          color: #2196f3 !important;
          background: rgba(#2196f3, 0.08) !important;

          ::v-deep .v-icon {
            color: #2196f3 !important;
          }

          &:hover {
            background: rgba(#2196f3, 0.12) !important;
          }
        }
      }
    }
  }

  .no-images {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
    border: 2px dashed $border-color;
    border-radius: 12px;
    background: $bg-light;

    p {
      margin-top: 12px;
      font-size: 14px;
      font-weight: 500;
    }
  }

  // ============================================
  // FORM CONTROLS
  // ============================================
  .form-label {
    font-size: 12px;
    font-weight: 700;
    color: $text-primary;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .v-icon {
      flex-shrink: 0;
    }

    .text-danger {
      color: $danger-color;
    }

    small {
      font-size: 10px;
      opacity: 0.8;
      text-transform: none;
      font-weight: 500;
      letter-spacing: 0;
    }
  }

  .form-control {
    ::v-deep {
      .v-input__slot {
        border-radius: 8px !important;
      }

      .v-text-field--outlined,
      .v-select--is-menu-active {
        fieldset {
          border-color: $border-color;
          transition: all 0.3s ease;
        }
      }

      .v-text-field:hover {
        fieldset {
          border-color: $primary-color;
        }
      }
    }
  }

  // ============================================
  // ACTION BUTTONS
  // ============================================
  .action-buttons {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 2px solid $border-color;

    .action-btn {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      font-weight: 700;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
      margin: 0 8px;

      &.approve-btn {
        background: linear-gradient(
          135deg,
          $success-color 0%,
          #059669 100%
        ) !important;
        color: white !important;

        &:hover:not(:disabled) {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(16, 185, 129, 0.4) !important;
        }
      }

      &.reject-btn {
        background: linear-gradient(
          135deg,
          $warning-color 0%,
          #d97706 100%
        ) !important;
        color: white !important;

        &:hover:not(:disabled) {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(245, 158, 11, 0.4) !important;
        }
      }

      &.cancel-btn {
        background: $gradient-main !important;
        color: white !important;

        &:hover:not(:disabled) {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(102, 126, 234, 0.4) !important;
        }
      }

      .v-icon {
        margin-right: 8px;
      }
    }
  }

  // ============================================
  // APPROVAL CARD
  // ============================================
  .approval-card {
    border: 2px solid $danger-color !important;
    background: linear-gradient(
      135deg,
      rgba(244, 67, 54, 0.05) 0%,
      rgba(244, 67, 54, 0.02) 100%
    );

    .card-header {
      background: linear-gradient(
        135deg,
        rgba(244, 67, 54, 0.12) 0%,
        rgba(244, 67, 54, 0.08) 100%
      );
      border-bottom-color: $danger-color !important;
    }
  }

  // ============================================
  // UTILITY CLASSES
  // ============================================
  .d-flex {
    display: flex;
  }

  .justify-center {
    justify-content: center;
  }

  .align-center {
    align-items: center;
  }

  .text-danger {
    color: $danger-color;
    font-weight: 700;
  }

  .white--text {
    color: white;
  }

  .my-6 {
    margin: 24px 0;
  }

  .my-0 {
    margin: 0;
  }

  .mb-6 {
    margin-bottom: 24px;
  }

  .mb-3 {
    margin-bottom: 12px;
  }

  .mt-6 {
    margin-top: 24px;
  }

  .mt-2 {
    margin-top: 8px;
  }

  .mt-3 {
    margin-top: 12px;
  }

  .mr-2 {
    margin-right: 8px;
  }

  .mr-1 {
    margin-right: 4px;
  }

  .ml-2 {
    margin-left: 8px;
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 960px) {
    .preview-header {
      padding: 24px;

      .header-content {
        flex-wrap: wrap;
        gap: 12px;
      }

      .header-text {
        .header-title {
          font-size: 22px;
        }

        .header-subtitle {
          font-size: 12px;
        }
      }
    }

    .preview-card {
      margin: -16px 8px 20px 8px;
    }

    .preview-content-area {
      padding: 24px;
    }

    .action-buttons {
      .action-btn {
        margin: 8px 4px;
        font-size: 12px !important;
      }
    }
  }

  @media (max-width: 600px) {
    .preview-header {
      padding: 16px;

      .header-content {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
      }

      .header-icon-box {
        width: 40px;
        height: 40px;
        padding: 8px;

        ::v-deep .v-icon {
          font-size: 24px !important;
        }
      }

      .header-text {
        width: 100%;

        .header-title {
          font-size: 18px;
        }

        .header-subtitle {
          font-size: 11px;
        }
      }

      .close-btn-header {
        width: 36px !important;
        height: 36px !important;
        right: 8px !important;
        top: 8px !important;
      }
    }

    .preview-card {
      border-radius: 12px !important;
      margin: -12px 6px 16px 6px;
    }

    .preview-content-area {
      padding: 16px;
    }

    .detail-card {
      .card-header {
        padding: 16px;
        flex-direction: column;
        align-items: flex-start;

        .card-title {
          font-size: 14px;
        }
      }

      .card-content {
        padding: 16px;
      }
    }

    .detail-item {
      .detail-value {
        font-size: 12px;
      }
    }

    .image-gallery {
      .gallery-container {
        gap: 8px;
      }

      .gallery-item {
        .gallery-image {
          width: 80px;
          height: 80px;
        }
      }
    }

    .action-buttons {
      flex-direction: column;

      .action-btn {
        width: 100%;
        margin: 6px 0 !important;
      }
    }
  }
}
</style>